export type ApiResult<T> =
    | { ok: true, data: T }
    | { ok: false, message: string }

const OFFLINE_MESSAGE = "That didn't save. Check your connection and try again."
const FAILED_MESSAGE = "That didn't save right now. Try again in a moment."

export async function apiRequest<T>(url: string, method: 'POST' | 'PATCH', body: unknown): Promise<ApiResult<T>> {
    try {
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
        const payload = await response.json().catch(() => null) as (T & { message?: string }) | null

        if (!response.ok || !payload) {
            return { ok: false, message: payload?.message || FAILED_MESSAGE }
        }

        return { ok: true, data: payload }
    }
    catch {
        return { ok: false, message: OFFLINE_MESSAGE }
    }
}
